module.exports = __webpack_public_path__ + "img/logo.980103f5.png";